import { Injectable } from '@angular/core';
import { ApiService, } from './api.service';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { Profile } from '../models/index';
import { SelectItem } from '../../shared/models/index';

import { getSingleResponse, getResponse, updateResponse } from './api.service';

import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

@Injectable()
export class ProfilerService extends ApiService<Profile> {

	protected apiName: string = 'profiler';

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {
		super(http, translate, confirmationService, messageService);
	}

	/*loadProfiles(): Observable<getSingleResponse<Profile>> {
		return this.http.get<getSingleResponse<Profile>>(
			this.getBaseUrl('loadprofiles')
		).retry(this.retries);
	}*/

	loadProfiles(parameters: object = {}): Observable<getResponse<Profile>> {
	   return this.http.post<getResponse<Profile>>(
		   this.getBaseUrl('loadprofiles'),
		   parameters
	   ).retry(this.retries);
	}

	addSubscriptionsToProfile(profileId: number, contactIds: Array<number>): Observable<addSubResponse> {
		return this.http.post<addSubResponse>(
			this.getBaseUrl('addsubscriptionstoprofile'),
			{
				profile_id: profileId,
				contact_ids: contactIds
			}
		);
	}

	removeSubscriptionsFromProfile(profileId: number, subscriptionIds: Array<number>): Observable<addSubResponse> {
		return this.http.post<addSubResponse>(
			this.getBaseUrl('removesubscriptionsfromprofile'),
			{
				profile_id: profileId,
				subscription_ids: subscriptionIds
			}
		);
	}

	/*loadProfiler(): Observable<Profile> {
		return this.retrieveProfiler().map(response => {
			this.settings = response.data;
			return this.settings;
		});
	}*/

	/**
	 * getSingle(id)
	 * Retrieve single object
	 */
	/*retrieveProfiler(): Observable<getSingleResponse<Profiler>> {
		return this.http.get<getSingleResponse<Profiler>>(
			this.getBaseUrl('get')
		).retry(this.retries);
	}*/

	/**
	 *
	 */
	/*update(data: Profiler): Observable<updateResponse<Profiler>> {
		return this.http.post<updateResponse<Profiler>>(
			this.getBaseUrl('update'),
			data
		);
	}*/

}

interface addSubResponse {
	success: boolean;
	error: string;
	num_subscribers: number;
	results: {
		added: number;
		already_added: number;
		failed: number;
	}
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/services/profiler.service.ts